import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';
import type { TLoansCalculationData, TLoansCalculationResponse } from 'shared/types/TLoansService';

export const sendLoansCalculationDataApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    sendLoansCalculationData: build.mutation<TLoansCalculationResponse, TLoansCalculationData>({
      query: (query) => ({
        url: BFF_API_ROUTES.sendCalculation,
        method: 'POST',
        body: query,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
